// extracted by mini-css-extract-plugin
export var multipleAuthors = "post-module--multipleAuthors--44e25";
export var subtitle = "post-module--subtitle--70d17";